module.exports = __webpack_public_path__ + "img/20201204.41b38136.png";